var map = {
	"./auth.js": "UhQU",
	"./validate.js": "N0Hw"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "VCn8";


//////////////////
// WEBPACK FOOTER
// ./src/directives nonrecursive ^\.\/.*\.js$
// module id = VCn8
// module chunks = 12